import Vue from 'vue';
import ToggleCheckbox from 'src/components/widgets/ToggleCheckbox.vue';
export default Vue.extend({
    name: 'TreeItem',
    components: { ToggleCheckbox },
    props: {
        item: { type: Object, default: () => null },
        depth: { type: Number, default: 0 },
        showFiles: { type: Boolean, default: true },
        showFolders: { type: Boolean, default: true },
        allowSelectFile: { type: Boolean, default: true },
        allowSelectFolder: { type: Boolean, default: true },
        allowAdd: { type: Boolean, default: false },
        allowMakeFolder: { type: Boolean, default: false },
        indent: { type: Number, default: 30 },
        itemClassLookup: { type: Function, default: (item) => '' },
        selectedKeys: { type: Object, default: () => null },
        startOpen: { type: Boolean, default: false }
    },
    data() {
        return {
            isOpen: this.startOpen,
            itemSelected: false,
            logger: this.$logger.getLogger('TreeItem')
        };
    },
    computed: {
        isFolder: function () {
            return this.item.children && this.item.children.length;
        },
        itemIsSelected: function () {
            return this.selectedKeys.hasOwnProperty(this.item.key);
        }
    },
    methods: {
        selChildCount() {
            this.logger.trace(`in selChildCount for item: ${JSON.stringify(this.item)}`);
            // Count how many nested keys appear in the selected Keys
            let nestedChildren = this.item.nestedChildren();
            let nestedKeys = nestedChildren.map((item) => item.key);
            let nestedKeysSet = new Set(nestedKeys);
            let count = 0;
            for (const key of Object.keys(this.selectedKeys)) {
                if (nestedKeysSet.has(key)) {
                    count = count + 1;
                }
            }
            return count;
        },
        change(item) {
            this.$emit('change', item);
        },
        selectionChanged(item, oldval, newval) {
            this.$emit('selectionChanged', item, oldval, newval);
        },
        toggle: function () {
            if (this.isFolder) {
                this.isOpen = !this.isOpen;
            }
        },
        makeFolder: function () {
            if (!this.allowMakeFolder) {
                return;
            }
            if (!this.isFolder) {
                this.$emit('make-folder', this.item);
                this.isOpen = true;
            }
        }
    }
});
